import { connect } from 'react-redux';

import PurchaseInventoryStatus from '../components/purchase-inventory-status';

import {
  getCurrentPurchase,
} from '../selectors/purchase-selector';


const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);

  return {
    purchase,
  };
};

export default connect(mapStateToProps)(PurchaseInventoryStatus);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-inventory-status.container.js